/**
 * Product Categories Icons Catalog
 * Synchronized with Mobile Apps (PascalCase keys)
 * and Material Design Icons (@mdi/font classes for Backoffice Web UI).
 */

export const DEFAULT_CATEGORY_ICON_KEY = 'ShapeOutline';

export const CATEGORY_ICONS = [
  // Charcutería, Carnes y Pescados
  {
    key: 'FoodSteak',
    mdi: 'mdi-food-steak',
    label: 'Carne / Bistec / Cortes',
    category: 'Carnes y Charcutería',
  },
  {
    key: 'FoodDrumstick',
    mdi: 'mdi-food-drumstick',
    label: 'Pollo / Aves / Embutidos',
    category: 'Carnes y Charcutería',
  },
  {
    key: 'Fish',
    mdi: 'mdi-fish',
    label: 'Pescados / Mariscos / Del Mar',
    category: 'Carnes y Charcutería',
  },

  // Quesos, Lácteos y Yogurts
  {
    key: 'Cheese',
    mdi: 'mdi-cheese',
    label: 'Quesos / Mantequilla / Derivados',
    category: 'Lácteos',
  },
  {
    key: 'Cup',
    mdi: 'mdi-cup',
    label: 'Yogurt / Postres Lácteos',
    category: 'Lácteos',
  },
  {
    key: 'Egg',
    mdi: 'mdi-egg',
    label: 'Huevos / Postura',
    category: 'Lácteos',
  },

  // Abarrotes, Despensa y Salsas
  {
    key: 'BottleTonicOutline',
    mdi: 'mdi-bottle-tonic-outline',
    label: 'Salsas / Aceites / Vinagres',
    category: 'Abarrotes y Despensa',
  },
  {
    key: 'ShakerOutline',
    mdi: 'mdi-shaker-outline',
    label: 'Condimentos / Especias / Sal',
    category: 'Abarrotes y Despensa',
  },
  {
    key: 'Noodles',
    mdi: 'mdi-noodles',
    label: 'Pastas / Granos / Cereales',
    category: 'Abarrotes y Despensa',
  },

  // Bebidas y Jugos
  {
    key: 'GlassCocktail',
    mdi: 'mdi-glass-cocktail',
    label: 'Jugos / Refrescos / Bebidas',
    category: 'Bebidas',
  },
  {
    key: 'Coffee',
    mdi: 'mdi-coffee',
    label: 'Café / Té / Infusiones',
    category: 'Bebidas',
  },
  {
    key: 'CupWater',
    mdi: 'mdi-cup-water',
    label: 'Agua / Hidratación',
    category: 'Bebidas',
  },

  // Enlatados y Conservas
  {
    key: 'Can',
    mdi: 'mdi-package-variant-closed',
    label: 'Enlatados / Conservas / Atún',
    category: 'Enlatados',
  },

  // Congelados
  {
    key: 'Snowflake',
    mdi: 'mdi-snowflake',
    label: 'Alimentos Congelados / Hielo',
    category: 'Congelados',
  },
  {
    key: 'IceCream',
    mdi: 'mdi-ice-cream',
    label: 'Helados / Postres Fríos',
    category: 'Congelados',
  },

  // Panadería y Repostería
  {
    key: 'BreadSlice',
    mdi: 'mdi-bread-slice',
    label: 'Panadería / Masas / Harinas',
    category: 'Panadería y Dulces',
  },
  {
    key: 'CakeVariant',
    mdi: 'mdi-cake-variant',
    label: 'Pastelería / Tortas / Repostería',
    category: 'Panadería y Dulces',
  },

  // Confitería y Golosinas
  {
    key: 'Candy',
    mdi: 'mdi-candy',
    label: 'Caramelos / Chucherías / Chicles',
    category: 'Panadería y Dulces',
  },
  {
    key: 'Cookie',
    mdi: 'mdi-cookie',
    label: 'Galletas / Snacks Dulces',
    category: 'Panadería y Dulces',
  },

  // Frutas y Verduras
  {
    key: 'FruitCherries',
    mdi: 'mdi-fruit-cherries',
    label: 'Frutas / Pulpa / Vegetales',
    category: 'Frescos y Verduras',
  },

  // Limpieza y Hogar
  {
    key: 'Broom',
    mdi: 'mdi-broom',
    label: 'Limpieza / Higiene / Detergentes',
    category: 'Limpieza y Hogar',
  },
  {
    key: 'SprayBottle',
    mdi: 'mdi-spray-bottle',
    label: 'Desinfectantes / Químicos',
    category: 'Limpieza y Hogar',
  },

  // General y Tienda
  {
    key: 'Fridge',
    mdi: 'mdi-fridge-outline',
    label: 'Refrigerados / Lácteos / Frío',
    category: 'Lácteos',
  },
  {
    key: 'Popcorn',
    mdi: 'mdi-popcorn',
    label: 'Snacks / Pasabocas / Complementos',
    category: 'Abarrotes y Despensa',
  },
  {
    key: 'CubeOutline',
    mdi: 'mdi-cube-outline',
    label: 'Azúcar / Endulzantes / Endulzado',
    category: 'Abarrotes y Despensa',
  },
  {
    key: 'FoodCroissant',
    mdi: 'mdi-food-croissant',
    label: 'Pasapalos / Pastelitos / Entradas',
    category: 'Panadería y Dulces',
  },
  {
    key: 'StoreOutline',
    mdi: 'mdi-store-outline',
    label: 'Comercial / Tienda General',
    category: 'General',
  },
  {
    key: 'CartOutline',
    mdi: 'mdi-cart-outline',
    label: 'Mercancía General / Abarrotes',
    category: 'General',
  },
  {
    key: 'PackageVariant',
    mdi: 'mdi-package-variant',
    label: 'Bultos / Mayorista / Caja',
    category: 'General',
  },
  {
    key: 'RoomService',
    mdi: 'mdi-room-service',
    label: 'Servicios / Alquileres / Atención',
    category: 'General',
  },
  {
    key: 'HelpCircleOutline',
    mdi: 'mdi-help-circle-outline',
    label: 'Indefinido / Varios / Sin Clasificar',
    category: 'General',
  },
  {
    key: 'ShapeOutline',
    mdi: 'mdi-shape-outline',
    label: 'Categoría Estándar',
    category: 'General',
  },
];

/**
 * Returns metadata for a given icon key or legacy kebab-case MDI string.
 * Ensures an icon object is always returned with valid fallback.
 */
export const getCategoryIconMeta = (iconKeyOrMdi) => {
  if (!iconKeyOrMdi) {
    return {
      key: '',
      mdi: 'mdi-shape-outline',
      label: 'Sin Ícono Asignado',
      category: 'Ninguna',
    };
  }

  // Direct key match
  let found = CATEGORY_ICONS.find((i) => i.key === iconKeyOrMdi);
  if (found) return found;

  // Normalized search
  const normalizedSearch = iconKeyOrMdi.toLowerCase().replace(/[^a-z0-9]/g, '');
  found = CATEGORY_ICONS.find(
    (i) => i.key.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedSearch ||
           i.mdi.toLowerCase().replace(/[^a-z0-9]/g, '') === normalizedSearch
  );
  if (found) return found;

  // Dynamic fallback for any MDI string
  const isMdi = iconKeyOrMdi.startsWith('mdi-');
  return {
    key: iconKeyOrMdi,
    mdi: isMdi ? iconKeyOrMdi : `mdi-${iconKeyOrMdi.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase()}`,
    label: iconKeyOrMdi,
    category: 'Personalizado',
  };
};
